export const lemon = {
    lemonLightest: '#fefaea',
    lemonLight: '#fbedb8',
    lemon: '#f6dc72',
    lemonDark: '#d9bf55',
    lemonDarkest: '#706232',
};
